const initElement = ($el) => {
    const speed = $el.dataset.speed ? Number($el.dataset.speed) : 0.3;
    const direction = $el.dataset.direction || "down";

    const handleScroll = () => {
        try {
            const scrollPosition = window.scrollY;
            const scrollDiff =
                direction === "down" ? scrollPosition : -scrollPosition;
            const diff = scrollDiff * speed;
            const transformY = `translateY(${diff}px)`;

            $el.style.transform = transformY;
        } catch (e) {
            console.log(e);
        }
    };

    handleScroll()

    $el.style.opacity = 1

    document.addEventListener("scroll", handleScroll);
};

const init = () => {
    const elements = document.querySelectorAll(".ns-parallax-element");

    elements.forEach(($el) => {
        initElement($el);
    });
};

window.addEventListener("DOMContentLoaded", init, false);
